import { IncidentType } from '@/graphql/generated/schemas'
import { IncidentActionType, SystemAction } from '@/graphql/generated/schemas'
import { MeStateIProps } from '@/redux/me/meSlice'
import { uuid } from '@/utils/helpers'

import {
  CannedIncidentActionType,
  IncidentActionType as IncidentAction,
  IncidentAudioMessageType,
  IncidentEventType,
  IncidentNoteType,
  TimelineOrder,
} from '../types/types'
import { NonActionItem } from '../types/types'

export const getDescriptionMessage = (type: IncidentType) => {
  switch (type) {
    case IncidentType.Tailgating:
      return 'Multiple people passed through a restricted entrance with only one authorized credential.'
    default:
      return ''
  }
}

export const getActivityTimeline = (
  actions: IncidentAction[],
  events: IncidentEventType,
  audioMessages: IncidentAudioMessageType[],
  notes: IncidentNoteType[],
  me: MeStateIProps,
  shouldShowEmailActions: boolean,
  order: TimelineOrder = TimelineOrder.Desc
) => {
  const hiddenIncidentActions = [
    IncidentActionType.Dispatch,
    IncidentActionType.SendToOntic,
  ]
  const incidentActions = actions.filter(
    (action) => !hiddenIncidentActions.includes(action?.type)
  )

  const updatedIncidentActions = shouldShowEmailActions
    ? addCannedEmailActions(incidentActions, me)
    : incidentActions

  const noteActions = notes.map((note) => ({
    nonActionType: NonActionItem.IncidentNote,
    ...note,
  }))

  const audioMessageActions = audioMessages.map((audioMessage) => ({
    nonActionType: NonActionItem.AudioMessage,
    ...audioMessage,
  }))
  const systemMessages = events
    .filter((item) =>
      Object.prototype.hasOwnProperty.call(item, 'systemMessage')
    )
    .map((systemMessage) => ({
      nonActionType: NonActionItem.SystemAction,
      ...systemMessage,
    })) as unknown as SystemAction[]

  return [
    ...updatedIncidentActions,
    ...audioMessageActions,
    ...noteActions,
    ...systemMessages,
  ].sort((a, b) => {
    const aDate = new Date(a.createdAt).valueOf()
    const bDate = new Date(b.createdAt).valueOf()
    return order === TimelineOrder.Desc ? bDate - aDate : aDate - bDate
  })
}

// Should ONLY be used in the Sales enviornment.
// Used to add canned email actions for after every flag action
export const addCannedEmailActions = (
  actions: IncidentAction[],
  me: MeStateIProps
) =>
  actions.flatMap((action) => {
    if (action.type === IncidentActionType.Flag) {
      const cannedEmailAction = {
        id: uuid(),
        createdAt: action?.createdAt,
        type: CannedIncidentActionType.Email,
        __typename: CannedIncidentActionType.Email,
        creator: {
          id: me?.id,
          firstName: me?.firstName,
          lastName: me?.lastName,
          roleName: me?.roleName,
        },
      }
      return [cannedEmailAction, action]
    }
    return action
  })

export const shouldShowTraceLogs = (type: IncidentType) => {
  switch (type) {
    case IncidentType.DoorHeldOpen:
    case IncidentType.DoorHeldClose:
    case IncidentType.ForcedEntry:
    case IncidentType.LineCrossing:
    case IncidentType.Alarm:
    case IncidentType.Tailgating:
      return true
    default:
      return false
  }
}
